import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggled'],
  setup(__props, { emit }) {

const props = __props;

  const active = ref(false)

  

  

  const toggleSwitch = () => {
    active.value = !active.value
    emit('toggled', active.value)
  }

  onMounted(() => {
    active.value = props.value
  })

return { __sfc: true,active, props, emit, toggleSwitch, onMounted, ref }
}

})